// components/copilot/utils/clipboard.js
export async function copyToClipboard(text) {
  const val = String(text || "");
  if (!val) return false;

  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(val);
      return true;
    }
  } catch {
    // fall back below
  }

  try {
    const ta = document.createElement("textarea");
    ta.value = val;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "-1000px";
    ta.style.left = "-1000px";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return !!ok;
  } catch {
    return false;
  }
}
